import React, { useEffect, useMemo, useState } from 'react';
import { pickBy } from 'lodash';
import Badges from 'modules/common/components/Badge';

import Table from 'partial/components/Table';
import Select from 'partial/components/Select';
import SearchBar from 'partial/components/input/SearchBar';
import Pagination from 'partial/components/Pagination';
import ListPanel from 'partial/components/ListPanel';
import { useModuleContext } from 'partial/wrappers/ModuleWrapper';

import { useMaskNameList } from './hooks';

const INITIAL_STATE = {
  keyword: '',
  status: { label: 'All status', value: '' },
};

const statusOptions = [
  { label: 'All status', value: '' },
  { label: 'Pending', value: 'pending' },
  { label: 'Processing', value: 'processing' },
  { label: 'Approved', value: 'approved' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'Failed', value: 'failed' },
  { label: 'Success', value: 'success' },
];

const format = [
  { label: 'MASK NAME', key: 'name' },
  {
    label: 'AGENCY',
    key: 'organization_name',
    contentClassName: 'text-neutral-500',
  },
  {
    label: 'DATE REQUESTED',
    key: 'subscribed_at',
    contentClassName: 'tabular-nums text-neutral-500',
  },
  {
    label: 'DATE APPROVED',
    key: 'approved_at',
    contentClassName: 'tabular-nums text-neutral-500',
  },
  {
    label: 'EXPIRY DATE',
    key: 'expired_at',
    contentClassName: 'tabular-nums text-neutral-500',
  },
  { label: 'REMARKS', key: 'remarks', contentClassName: 'text-neutral-500' },
  {
    id: 'status',
    key: ({ status }) => <Badges status={status} />,
    labelClassName: 'whitespace-nowrap',
    contentClassName: 'whitespace-nowrap',
    label: 'STATUS',
  },
];

export function MaskNamesContent() {
  const { setSubLabel } = useModuleContext();

  const [filter, setFilter] = useState(INITIAL_STATE);
  const [page, setPage] = useState({ page: '' });
  const payload = useMemo(
    () =>
      pickBy({
        ...filter,
        ...page,
        status: filter?.status?.value,
      }),
    [filter, page],
  );

  useEffect(() => {
    setPage({ page: '' });
  }, [filter]);

  const [isLoading, list, meta] = useMaskNameList(payload);

  useEffect(() => {
    if (!meta) return;
    setSubLabel(
      meta?.total === 0
        ? ''
        : `Total of ${meta?.total} mask name${meta?.total === 1 ? '' : 's'}`,
    );
    return () => setSubLabel('');
  }, [meta, setSubLabel]);

  return (
    <ListPanel
      filters={
        <>
          <SearchBar
            name="keyword"
            value={filter.keyword}
            onChange={setFilter}
          />
          <Select
            name="status"
            onChange={setFilter}
            value={filter.status}
            data={statusOptions}
          />
        </>
      }
      summary={meta?.total ? `${list.length} of ${meta.total} shown` : null}
      pagination={
        +meta?.last_page > 1 ? (
          <Pagination value={meta} onChange={setPage} />
        ) : null
      }
    >
      <Table
        isLoading={isLoading}
        data={list}
        format={format}
        emptySpiel="No mask names match these filters."
      />
    </ListPanel>
  );
}

export default MaskNamesContent;
